export const diagnosisCardMenus = [
	{
		name: '通讯质量分析',
		key: 'communicateAnalyzeMsg',
		desc: '8天未通讯、最近一次通讯完整',
		analyzeTabIdx: 1,
		statusKey: 'communicateResult',
	},
	{
		name: '关阀分析',
		desc: '人工关阀、阀门直通',
		key: 'valveResultMsg',
		emptyText: '暂无关阀分析结果',
		analyzeTabIdx: 2,
	},
]

export const statusLengends = [
	{
		name: '正常',
		color: '#ABBDF6',
	},
	{
		name: '异常',
		color: '#E9A8A8',
	},
]

export const processNodes = [
	{
		id: 1,
		name: '运营商',
		isRealNode: true,
		x: '52%',
		y: '19%',
	},
	{
		id: 2,
		name: '连接平台',
		isRealNode: true,
		x: '38.2%',
		y: '39%',
	},
	{
		id: 'nbxt',
		name: 'NB协调服务',
		isRealNode: false,
		x: '65%',
		y: '39%',
	},
	{
		id: 3,
		name: 'transport',
		isRealNode: true,
		x: '52%',
		y: '50%',
	},
	{
		id: 4,
		name: 'dev-shadow',
		isRealNode: true,
		x: '52%',
		y: '64%',
	},
	{
		id: 'iot-monitor',
		name: 'iot-monitor',
		isRealNode: false,
		x: '11%',
		y: '75%',
	},
	{
		id: 5,
		name: 'iot-collection',
		isRealNode: true,
		x: '36%',
		y: '75%',
	},
	{
		id: 6,
		name: 'meter-collection',
		isRealNode: true,
		x: '67.2%',
		y: '75%',
	},
	{
		id: 'adapter',
		name: 'adapter\n下发指令',
		isRealNode: false,
		x: '11.2%',
		y: '94%',
	},
	{
		id: '7',
		name: '本地平台',
		isRealNode: false,
		x: '15.6%',
		y: '38.8%',
		noDetails: true,
	},
]
